export const KEYS = {
  token: 'app-token',
  id: 'app-user-id',
  selectedLanguage: 'selected-language'
}
